<script setup>
import { ref } from 'vue';
import Input from 'dashboard/components-next/input/Input.vue';
const props = defineProps({
  modelValue: { type: String, default: '00' },
  label: { type: String, default: 'Minutos' },
  disabled: Boolean,
});
const emit = defineEmits(['update:modelValue']);
const open = ref(false);
const choices = ['00', '30'];
function update(value) {
  if (props.disabled) return;
  emit('update:modelValue', String(value).replace(/\D/g, '').slice(0, 2));
}
function normalize() {
  if (/^\d$/.test(props.modelValue)) update(props.modelValue.padStart(2, '0'));
}
function select(value) {
  update(value);
  open.value = false;
}
function leave(event) {
  if (!event.currentTarget.contains(event.relatedTarget)) open.value = false;
}
</script>

<template>
  <div class="relative min-w-0" @focusout="leave" @keydown.esc="open = false">
    <Input
      :model-value="modelValue"
      :disabled="disabled"
      :aria-label="label"
      inputmode="numeric"
      maxlength="2"
      pattern="[0-5][0-9]"
      placeholder="00"
      custom-input-class="!pr-9 tabular-nums"
      autocomplete="off"
      @update:model-value="update"
      @blur="normalize"
    />
    <button
      type="button"
      class="absolute right-1 top-1 flex size-8 items-center justify-center rounded-md text-n-slate-11 hover:bg-n-alpha-2 disabled:opacity-50"
      :disabled="disabled"
      :aria-label="`${label}: sugestões 00 e 30`"
      :aria-expanded="open"
      @click="open = !open"
    >
      <span class="i-lucide-chevron-down size-4" aria-hidden="true" />
    </button>
    <div
      v-if="open && !disabled"
      class="absolute top-full z-50 mt-1 w-full rounded-lg border border-n-weak bg-n-solid-1 p-1 shadow-lg"
    >
      <button
        v-for="choice in choices"
        :key="choice"
        type="button"
        class="block w-full rounded-md px-3 py-2 text-left text-sm tabular-nums text-n-slate-12 hover:bg-n-alpha-2 focus:bg-n-alpha-2"
        @click="select(choice)"
      >
        {{ choice }}
      </button>
    </div>
  </div>
</template>
